(() => {
  const getVariantFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    const variant = params.get('variant');
    if (!variant) {
      return null;
    }
    const id = Number(variant);
    return Number.isFinite(id) ? id : null;
  };

  const initSection = (root) => {
    if (!root || root.dataset.ppctaInit === 'true') {
      return;
    }
    root.dataset.ppctaInit = 'true';

    const form = root.querySelector('.product-page-cta__form');
    const variantInput = root.querySelector('[data-ppcta-variant-input]');
    const submitButton = root.querySelector('[data-ppcta-submit]');
    const variantsJsonEl = root.querySelector('[data-ppcta-variants]');

    if (!form || !variantInput || !submitButton || !variantsJsonEl) {
      return;
    }

    let variants = [];
    try {
      variants = JSON.parse(variantsJsonEl.textContent || '[]');
    } catch (error) {
      variants = [];
    }

    const variantMap = new Map(variants.map((item) => [Number(item.id), Boolean(item.available)]));
    const fallbackId = Number(variantInput.value);

    const sync = () => {
      const urlVariantId = getVariantFromUrl();
      const activeVariantId = urlVariantId && variantMap.has(urlVariantId) ? urlVariantId : fallbackId;

      if (activeVariantId) {
        variantInput.value = String(activeVariantId);
      }

      const isAvailable = variantMap.has(activeVariantId) ? variantMap.get(activeVariantId) : true;
      submitButton.disabled = !isAvailable;
    };

    form.addEventListener('submit', sync);
    window.addEventListener('popstate', sync);
    document.addEventListener('change', sync, { passive: true });

    sync();
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-product-page-cta]').forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
